import { render, staticRenderFns } from "./Create-New-Equipment.vue?vue&type=template&id=04d39c25&scoped=true"
import script from "./Create-New-Equipment.vue?vue&type=script&lang=js"
export * from "./Create-New-Equipment.vue?vue&type=script&lang=js"
import style0 from "./Create-New-Equipment.vue?vue&type=style&index=0&id=04d39c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d39c25",
  null
  
)

export default component.exports